/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_New_Invoice_Warning_Not_SentInputs */

const en_admin_external_booking_new_invoice_warning_not_sent = /** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating this booking will generate an invoice.`)
};

const de_admin_external_booking_new_invoice_warning_not_sent = /** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Buchung löst eine Rechnung aus.`)
};

const es_admin_external_booking_new_invoice_warning_not_sent = /** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al crear esta reserva se generará una factura.`)
};

const fr_admin_external_booking_new_invoice_warning_not_sent = /** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La création de cette réservation générera une facture.`)
};

/** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */
const it_admin_external_booking_new_invoice_warning_not_sent = en_admin_external_booking_new_invoice_warning_not_sent;

/** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */
const pt_br2_admin_external_booking_new_invoice_warning_not_sent = en_admin_external_booking_new_invoice_warning_not_sent;

/** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */
const pl_admin_external_booking_new_invoice_warning_not_sent = en_admin_external_booking_new_invoice_warning_not_sent;

/** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */
const hu_admin_external_booking_new_invoice_warning_not_sent = en_admin_external_booking_new_invoice_warning_not_sent;

/** @type {(inputs: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs) => LocalizedString} */
const ro_admin_external_booking_new_invoice_warning_not_sent = en_admin_external_booking_new_invoice_warning_not_sent;

/**
* | output |
* | --- |
* | "Creating this booking will generate an invoice." |
*
* @param {Admin_External_Booking_New_Invoice_Warning_Not_SentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_new_invoice_warning_not_sent = /** @type {((inputs?: Admin_External_Booking_New_Invoice_Warning_Not_SentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_New_Invoice_Warning_Not_SentInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_new_invoice_warning_not_sent(inputs)
	if (locale === "de") return de_admin_external_booking_new_invoice_warning_not_sent(inputs)
	if (locale === "es") return es_admin_external_booking_new_invoice_warning_not_sent(inputs)
	if (locale === "fr") return fr_admin_external_booking_new_invoice_warning_not_sent(inputs)
	if (locale === "it") return it_admin_external_booking_new_invoice_warning_not_sent(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_new_invoice_warning_not_sent(inputs)
	if (locale === "pl") return pl_admin_external_booking_new_invoice_warning_not_sent(inputs)
	if (locale === "hu") return hu_admin_external_booking_new_invoice_warning_not_sent(inputs)
	return ro_admin_external_booking_new_invoice_warning_not_sent(inputs)
});
export { admin_external_booking_new_invoice_warning_not_sent as "admin.external_booking_new.invoice_warning_not_sent" }